/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { colors } from './styles/colors';
import fonts, { fontSizes } from './styles/fonts';
import { lineHeights } from './styles/spacing';
import marginPropStyles, {
  MarginProps
} from './styles/internal/marginPropStyles';
import { overflowEllipsesStyle, TextProps } from './styles/text';
import * as React from 'react';
import styled from 'styled-components';
interface Props
  extends React.HTMLProps<HTMLHeadingElement>,
    MarginProps,
    TextProps {
  size: 1 | 2 | 3 | 4 | 5;
  bold?: boolean;
}

const Heading: React.FC<Props> = ({ size, children, ...restProps }: Props) => {
  switch (size) {
    case 1:
    default:
      return <h1 {...restProps}>{children}</h1>;
    case 2:
      return <h2 {...restProps}>{children}</h2>;
    case 3:
      return <h3 {...restProps}>{children}</h3>;
    case 4:
      return <h4 {...restProps}>{children}</h4>;
    case 5:
      return <h5 {...restProps}>{children}</h5>;
  }
};

// We do this to filter out unwanted props that should not end up on the heading tag DOM node
export const AtomHeading = styled(
  ({ color, width, height, children, bold, ...restProps }): JSX.Element => (
    <Heading {...restProps}>{children}</Heading>
  )
)<Props>`
  color: ${(props: Props) => props.color || colors.grey100};
  font: ${(props: Props) =>
    props.bold ? fonts.bold(fontSizes.h1) : fonts.normal(fontSizes.h1)};
  font-size: ${(props: Props) =>
    (fontSizes as { [index: string]: string })[`h${props.size}`]};
  line-height: ${(props: Props) =>
    lineHeights[`h${props.size}` as keyof typeof lineHeights]};
  margin: 0;
  ${marginPropStyles}
  ${({ overflow }) => overflow === 'ellipses' && overflowEllipsesStyle};
`;

AtomHeading.defaultProps = {
  bold: true
};

export default AtomHeading;
